<template>
    <div :class="theme.radio">
        <div @click="handleClick" :class="theme.radioOverlay" v-ripple="'rgba(3, 169, 244, .15)'"></div>
        <radio-raw :disabled="disabled" :value="value" :data="data" />
        <slot name="label">
            <span :class="theme.label">
                {{ label }}
            </span>
        </slot>    
    </div>
</template>
<script>
    import { Ripple } from '../../directives';
    import RadioRaw from './RadioRaw.vue';
    import theme from './radio.scss';

    export default {
        name: 'radio',
        props: {
            label: String,
            clickEvent: Function,
            value: [String, Number, Boolean, Object],
            data: [String, Number, Boolean, Object],
            disabled: Boolean,
        },
        components: { RadioRaw },
        directives: { Ripple },
        data() {
            return {
                theme,
            };
        },
        methods: {
            handleClick() {
                if (!this.disabled) {
                    this.$emit('input', this.data);
                    if (this.clickEvent) {
                        this.clickEvent(this.data)
                    }
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Radio.vue?21b3837b